import type { AccessControlFormSchemaValues } from "../schemas/access-control-form.schema";

export const ACCESS_CONTROL_FORM_DEFAULT_VALUES: AccessControlFormSchemaValues =
  {
    role: "",
    company: "",
  };
